export default window.Raven;
